import useSlugExtractor from "@hooks/useSlugExtractor"

import { AccessCheck } from "@particles/index"

import { NavTopBar } from "@organisms"
import ViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider"

import { AppFrame } from "@templates"

import { CREDIT_NOTES_ROUTES } from "@routes/creditNotes"

import { objectMap } from "@constants/objectMap"
import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import { CREDIT_NOTES_LIST_CONTROLS_VIEW } from "@constants/storage"

import CreditNoteTableView from "./views/CreditNoteTableView/CreditNoteTableView"

export default function CreditNoteList() {
    const [createRoute] = useSlugExtractor([CREDIT_NOTES_ROUTES.CREATE])

    return (
        <AppFrame.Root collaborationRoomName="credit-note-list">
            <ViewTypesProvider
                viewTypes={["table"]}
                viewTypeKey={CREDIT_NOTES_LIST_CONTROLS_VIEW}
                defaultViewType="table"
            >
                {() => (
                    <>
                        <NavTopBar.Root>
                            <NavTopBar.Header>
                                <NavTopBar.NavTopBarHeaderStart>
                                    <NavTopBar.PageTitle
                                        label={objectMap.credit_note.labelPlural}
                                        icon={objectMap.credit_note.iconActive}
                                    />
                                </NavTopBar.NavTopBarHeaderStart>
                                <NavTopBar.NavTopBarHeaderEnd>
                                    <NavTopBar.PagePresence />
                                    <AccessCheck
                                        permissions={{
                                            invoices_list_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <AccessCheck
                                            permissions={{
                                                invoices_view_permission: PERMISSION_LEVEL.FULL,
                                            }}
                                        >
                                            <NavTopBar.SearchButton scope="Credit notes" />
                                        </AccessCheck>
                                    </AccessCheck>
                                    <AccessCheck
                                        permissions={{
                                            invoices_create_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <NavTopBar.CTAButton destination={createRoute} />
                                    </AccessCheck>
                                </NavTopBar.NavTopBarHeaderEnd>
                            </NavTopBar.Header>
                        </NavTopBar.Root>
                        <CreditNoteTableView />
                    </>
                )}
            </ViewTypesProvider>
        </AppFrame.Root>
    )
}
